import React from "react";

// 画面上部の品番見出し帯の描画。
// 本文は HinbanMaster.js から移設したもの。

export function createHinbanHeadlineRenderer(deps) {
    const {
        DicVal,
        formatHinbanHeadlineValue,
        headlineColumnInfo,
        headlineEntryData,
        isEmpty
    } = deps;

    function renderHinbanHeadline() {
        if (isEmpty(headlineColumnInfo) || isEmpty(headlineEntryData)) return null;
        const coldef = headlineColumnInfo.filter(e => e.logpid === "0" && (e.primary || e.required || e.headerfix === 1));
        if (coldef.length === 0) return null;
        const items = coldef
            .filter(e => e.headerfix !== 2)
            .map((field) => ({
                id: field.columnid,
                name: String(DicVal(field, "columnnm", "")).replace('★', '').replace('♯', ''),
                value: formatHinbanHeadlineValue(field, headlineEntryData),
                primary: field.primary
            }));
        return (
            <div className="hinban-headline">
                {items.map((item) => (
                    item.primary ?
                        <span key={item.id} className="hinban-headline-item hinban-headline-item--primary">{item.name}〔{item.value}〕</span>
                        :
                        <span key={item.id} className="hinban-headline-item">{item.name}〔{item.value}〕</span>
                ))}
            </div>
        );
    }

    return {
        renderHinbanHeadline
    };
}
